// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"2e76b7ee","122":"146c1747","256":"1a3de12a","398":"0a45f6b2","420":"f30c488e","662":"ec86e6d0","700":"ed8b7c86","844":"78bb9c4e","902":"12d9a8c0"}[chunkId] + ".chunk.js";
};